import { apiRequest } from './index';

/**
 * Fetch all agents
 *
 * @returns {Promise<Array>} List of agents
 */
export const fetchAgents = async () => {
  try {
    const response = await apiRequest({
      url: `/api/agents.php?method=get_all`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching agents:', error);
    throw error;
  }
};

/**
 * Fetch a single agent by ID
 *
 * @param {number} id Agent ID
 * @returns {Promise<Object>} Agent data
 */
export const fetchAgent = async (id) => {
  try {
    const response = await apiRequest({
      url: `/api/agents.php?method=get&id=${id}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching agent with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Add a new agent
 *
 * @param {Object} data Agent data
 * @returns {Promise<Object>} Result with new agent ID
 */
export const addAgent = async (data) => {
  try {
    const response = await apiRequest({
      url: '/api/agents.php?method=add',
      method: 'POST',
      data
    });

    return response.data;
  } catch (error) {
    console.error('Error adding agent:', error);
    throw error;
  }
};

/**
 * Update an existing agent
 *
 * @param {Object} data Agent data with ID
 * @returns {Promise<Object>} Result data
 */
export const updateAgent = async (data) => {
  try {
    const response = await apiRequest({
      url: `/api/agents.php?method=edit&id=${data.id}`,
      method: 'POST',
      data
    });

    return response.data;
  } catch (error) {
    console.error(`Error updating agent with ID ${data.id}:`, error);
    throw error;
  }
};

/**
 * Delete an agent
 *
 * @param {number} id Agent ID
 * @returns {Promise<Object>} Result data
 */
export const deleteAgent = async (id) => {
  try {
    const response = await apiRequest({
      url: `/api/agents.php?method=delete&id=${id}`,
      method: 'POST'
    });

    return response.data;
  } catch (error) {
    console.error(`Error deleting agent with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Fetch agent with schedule
 *
 * @param {number} id Agent ID
 * @returns {Promise<Object>} Agent data with schedule
 */
export const fetchAgentWithSchedule = async (id) => {
  try {
    const response = await apiRequest({
      url: `/api/agents.php?method=get_with_schedule&id=${id}`,
      method: 'GET'
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching agent with schedule for ID ${id}:`, error);
    throw error;
  }
};

/**
 * Sync agents from HelpScout
 *
 * @returns {Promise<Object>} Sync result
 */
export const syncAgentsFromHelpScout = async () => {
  try {
    const response = await apiRequest({
      url: '/api/agents.php?method=sync_from_helpscout',
      method: 'POST'
    });

    return response.data;
  } catch (error) {
    console.error('Error syncing agents from HelpScout:', error);
    throw error;
  }
};
